import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';
import Link from 'next/link';
import React from 'react';

export default function Breadcrumbs({ separator }: { separator?: string }) {
  const { breadcrumbs: items, setBreadCrumbs } = useBreadcrumbs();
  const constructElem = (item: UseBreadcrumbsProps, index: number) => {
    return (
      <span
        className={clsx('flex items-center gap-2', {
          'text-fiona-gray-2': index === 0,
        })}
      >
        {index == 0 && <ArrowLeftIcon className="text-fiona size-5 hover:cursor-pointer" />}
        {item.label}
        {index < items.length - 1 && <span className=" text-gray-300">{separator || '/'}</span>}
      </span>
    );
  };
  return (
    <div className="my-4 flex items-center gap-2 text-sm ">
      {items.map((item, index) => (
        <React.Fragment key={index}>
          {item.href ? (
            <Link href={item.href}>{constructElem(item, index)}</Link>
          ) : (
            constructElem(item, index)
          )}
        </React.Fragment>
      ))}
    </div>
  );
}

import { breadcrumbsAtom } from '@/app/states/atoms';
import { useAtom } from 'jotai';

export interface UseBreadcrumbsProps {
  label: string;
  href?: string | null;
}

export const useBreadcrumbs = () => {
  const [breadcrumbs, _setBreadcrumbs] = useAtom(breadcrumbsAtom);
  const setBreadCrumbs = (items: UseBreadcrumbsProps[]) => {
    _setBreadcrumbs(items);
  };

  return { breadcrumbs, setBreadCrumbs };
};
